document.addEventListener("DOMContentLoaded", function() {
  const wrapper = document.querySelector('.collection-grid-wrapper');
  const loadMoreBtn = document.querySelector('.load-more-btn');
  const spinner = document.querySelector('.load-more-spinner');
  const listContainer = document.querySelector('.collection-listing-loadmore');
  if (!wrapper || !listContainer || !loadMoreBtn) return;

  // Check if we're returning from a product page
  const scrollPosition = sessionStorage.getItem('collectionScrollPos');
  const savedIndex = sessionStorage.getItem('collectionCurrentIndex');
  const shouldRestore = performance.navigation.type === 2 || document.referrer.includes('/products/');

  // Hide content completely if restoring to prevent flash
  if (shouldRestore && scrollPosition) {
    wrapper.style.opacity = '0';
    wrapper.style.transition = 'none';
  }

  // hide grid until sorted
  wrapper.classList.remove('is-ready');

  const perPage = parseInt(wrapper.getAttribute('data-products-per-page')) || 100;
  let nextUrl = listContainer.getAttribute('data-next-url');
  let allProducts = Array.from(wrapper.children);
  let currentIndex = shouldRestore && savedIndex ? parseInt(savedIndex) : perPage;

  // Save scroll position and current index when clicking product links
  wrapper.addEventListener('click', function(e) {
    const productLink = e.target.closest('a[href*="/products/"]');
    if (productLink) {
      sessionStorage.setItem('collectionScrollPos', window.scrollY);
      sessionStorage.setItem('collectionCurrentIndex', currentIndex);
    }
  });

  async function fetchNextPage(url) {
    if (!url) return [];
    const res = await fetch(url);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newWrap = doc.querySelector('.collection-grid-wrapper');
    const newItems = newWrap ? Array.from(newWrap.children) : [];
    const nextEl = doc.querySelector('.collection-listing-loadmore');
    nextUrl = nextEl ? nextEl.getAttribute('data-next-url') : null;
    return newItems;
  }

  async function fetchAllPages() {
    while (nextUrl) {
      const newItems = await fetchNextPage(nextUrl);
      if (newItems.length === 0) break;
      allProducts = allProducts.concat(newItems);
    }
    sortProducts();
    
    // Restore scroll position BEFORE rendering if returning from product page
    if (shouldRestore && scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition));
    }
    
    renderPage();
    
    // Fade in content after scroll is set
    if (shouldRestore && scrollPosition) {
      requestAnimationFrame(() => {
        wrapper.style.transition = 'opacity 0.2s';
        wrapper.style.opacity = '1';
        sessionStorage.removeItem('collectionScrollPos');
        sessionStorage.removeItem('collectionCurrentIndex');
      });
    }
  }

  function sortProducts() {
    const inStock = allProducts.filter(el => !el.classList.contains('product-card--soldout'));
    const soldOut = allProducts.filter(el => el.classList.contains('product-card--soldout'));
    allProducts = inStock.concat(soldOut);
  }

  function renderPage() {
    wrapper.innerHTML = '';
    const slice = allProducts.slice(0, currentIndex);
    slice.forEach(el => wrapper.appendChild(el));

    // Insert "Sold Out" heading dynamically
    const firstSoldOut = wrapper.querySelector('.product-card--soldout');
    if (firstSoldOut) {
      const heading = document.createElement('h3');
      heading.textContent = 'Sold Out Products';
      heading.className = 'sold-out-heading';
      wrapper.insertBefore(heading, firstSoldOut);
    }

    if (currentIndex < allProducts.length) {
      loadMoreBtn.style.display = 'inline-block';
    } else {
      loadMoreBtn.style.display = 'none';
    }

    wrapper.classList.add('is-ready');
  }

  loadMoreBtn.addEventListener('click', function(e) {
    e.preventDefault();
    currentIndex += perPage;
    renderPage();
  });

  loadMoreBtn.style.display = 'none';
  if (spinner) spinner.style.display = 'block';
  fetchAllPages().then(() => {
    if (spinner) spinner.style.display = 'none';
  });
});
